//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  required,
  minLength
} from "vuelidate/lib/validators";

export default {
  data: function () {
    return {
      form: {
        name: "",
        phone: "",
      }
    };
  },

  computed: {
    isOpen: function () {
      return this.$store.state["dialog-not-avaible-notification"]?.open || false
    },

    errorName: function () {
      const error = this.$v?.form?.name;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }

      return null
    },
    errorPhone: function () {
      const error = this.$v?.form?.phone;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }
      if (!error.minLength) {
        return "Неправильный формат ввода"
      }

      return null
    },


    product: function () {
      return this.$store.state?.["dialog-not-avaible-notification"]?.product || {}
    },
    selectedVariants: function () {
      return this.$store.state?.["dialog-not-avaible-notification"]?.selectedVariants || {}
    },
  },

  validations: function() {
    const form = {
      name: { required },
      phone: { required, minLength: minLength(18) },
    };

    return {
      form
    };
  },

  methods: {
    close: function () {
      this.$store.commit("dialog-not-avaible-notification/setClose")
    },

    submitForm: async function () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }

      this.$store.commit("local-settings/setShowDialogLoading", true);

      const productVariants = this.product.variants || []
      let messages = [];
      this.selectedVariants.map((variant) => {
        let message = [];
        Object.keys(variant).map((key) => {
          const labelVariant = variant[key]?.label || ""
          const variantName = productVariants.find((t) => +key === +t.group_id)?.name || "";
          message.push(`${variantName}: ${ labelVariant }`)
        })
        messages.push(message.join(', '))
      })

      let modificationIds = [];
      await Promise.all(this.selectedVariants.map(async (selected) => {
        const search = `products/${this.product?.id}/modifications?${Object.keys(selected).map((key) => `v[${key}]=${selected[key]?.id}`).join('&')}`;
        const {data: modifications} = await this.$api.agent.transport.get(search);

        modificationIds.push(modifications?.[0]?.id)
      }));

      let source = [];
      modificationIds.map((modificationId) => {
        source.push({
          product_id: this.product.id,
          modifiacation_id: modificationId
        })
      })

      const response = await this.$api.agent.transport.post('/form/send', {
        ...this.form,
        phone: (this.form.phone || "").replace(/[^\d]/g, ''),
        type: "Заявка на линзы",
        message: `Здравствуйте, меня интересуют контактные линзы ${this.product.name}, с параметрами: ${messages.join("; ")}`,
        source: JSON.stringify(source),
        "no_mail_send": 1
      }).then((res) => {
        return res.data
      }).catch((err) => {
        return { error: err.response }
      })
      if (response.error) {
        this.$store.commit("local-settings/setShowDialogLoading", false);

        this.$toast.error(response.error?.data?.[0]?.message || response.error?.data?.message || "Ошибка сервера")

        return
      }

      this.form = {
        name: "",
        phone: "",
      };
      this.$store.commit("local-settings/setShowDialogLoading", false);
      this.$toast.success("Заявка успешно отправлена");
      this.close();
    }
  }
};
